import { vars } from '../../theme';
import styled from 'styled-components';

export const HighlightMark = styled.mark<{
    $highlightColor: string;
    $textColor?: string;
}>`
    background-color: ${({ $highlightColor }) => $highlightColor};
    color: ${({ $textColor }) => $textColor || 'inherit'};
    border-radius: ${vars.radius.xs};
    font-weight: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    display: inline-flex;
    white-space: pre-wrap;
`;

export const NonHighlightMark = styled.span`
    color: ${vars.colors.text.secondary};
    font-weight: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    display: inline-flex;
    white-space: pre-wrap;
`;
